// utils/listingScoreStorage.js
const LISTING_SCORE_KEY = 'landing_page_listing_score';

export const listingScoreStorage = {
  // Store both partial and full data
  store: (asin, fullData) => {
    try {
      const storageData = {
        asin: asin.toUpperCase(),
        timestamp: Date.now(),
        fullData: fullData,
        partialData: createPartialData(fullData)
      };
      localStorage.setItem(LISTING_SCORE_KEY, JSON.stringify(storageData));
    } catch (error) {
    }
  },

  // Get stored data for specific ASIN
  get: (asin) => {
    try {
      const stored = localStorage.getItem(LISTING_SCORE_KEY);
      if (!stored) return null;
      
      const data = JSON.parse(stored);
      if (data.asin !== asin.toUpperCase()) return null;
      
      return data;
    } catch (error) {
      return null;
    }
  },

  // Get full data if exists
  getFullData: (asin) => {
    const stored = listingScoreStorage.get(asin);
    return stored ? stored.fullData : null;
  },

  // Get partial data if exists
  getPartialData: (asin) => {
    const stored = listingScoreStorage.get(asin);
    return stored ? stored.partialData : null;
  },

  // Clear stored data
  clear: () => {
    try {
      localStorage.removeItem(LISTING_SCORE_KEY);
    } catch (error) {
    }
  },

  // Check if data exists for ASIN
  hasData: (asin) => {
    const stored = listingScoreStorage.get(asin);
    return stored !== null;
  },

  // Set flag to indicate this came from landing page
  setLandingPageFlag: () => {
    try {
      localStorage.setItem('listing_score_from_landing', 'true');
    } catch (error) {
    }
  },

  // Check and clear landing page flag
  getLandingPageFlag: () => {
    try {
      const flag = localStorage.getItem('listing_score_from_landing');
      if (flag) {
        localStorage.removeItem('listing_score_from_landing');
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  }
};

// Create partial data with limited information
function createPartialData(fullData) {
  if (!fullData || !fullData.data) return null;
  
  return {
    data: {
      asin: fullData.data.asin,
      title: fullData.data.title,
      main_image: fullData.data.main_image,
      analysis: {
        total_score: fullData.data.analysis?.total_score,
        overall_analysis: fullData.data.analysis?.overall_analysis,
        component_scores: fullData.data.analysis?.component_scores,
        // Hide detailed analysis, recommendations, etc.
        recommendations: [], // Empty for partial
        competitive_advantages: [], // Empty for partial  
        improvement_areas: [], // Empty for partial
        critical_gaps: [] // Empty for partial
      }
    }
  };
}

export default listingScoreStorage;
